import { useCallback } from "react";
import { useGenerateManagementYearSummaryReport } from "../services/reportService";

/**
 * Encapsulates the yearly management report PDF generation.
 */
export function useManagementYearSummaryReportHandler() {
  const generateManagementYearSummaryReport =
    useGenerateManagementYearSummaryReport();

  return useCallback(
    async (year: number, building_id: string): Promise<Blob | null> => {
      const blob = await generateManagementYearSummaryReport.mutateAsync({
        year,
        building_id,
      });
      return blob;
    },
    [generateManagementYearSummaryReport]
  );
}

